import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true,
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();
    return items.filter(item => {
      // Connections list fields.
      const fullName = `${item.firstName || ''} ${item.lastName || ''}`.toLowerCase();
      const title = (item.title || '').toLowerCase();
      const organisation = (item.organisation || '').toLowerCase();
      // Post-privacy modal also feeds Network / Community / Workspace items
      // through this pipe — without these fields their search box is dead.
      const networkName = (item.networkName || '').toLowerCase();
      const communityName = (item.communityName || '').toLowerCase();
      const teamName = (item.teamName || '').toLowerCase();

      return fullName.includes(searchText) ||
             title.includes(searchText) ||
             organisation.includes(searchText) ||
             networkName.includes(searchText) ||
             communityName.includes(searchText) ||
             teamName.includes(searchText);
    });
  }
}